import { createStore } from 'vuex'

export default createStore({
  state: {
    windowWidth: document.documentElement.clientWidth,
    windowHeight: document.documentElement.clientHeight,
    user: '',
    currentContract: '',
    myChart: '',
    // myChart1: '',
    myChart2: '',
    // myChart3: '',
    chatData: '',
    trendData: '',
    signalData: '',
    resonanceData: '',
    strategyData: '',
    marketData: '',
    rankData: '',
    returnData: '',
    technicalData: '',
    pickingData: '',
    correlationData: '',
    regressionData: '',
    hedgeData: '',
    historyData: '',
    backtestData: '',
    // infoData: '',
    meData: '',
  },
  mutations: {
    setWindowWidth (state, windowWidth) {
      state.windowWidth = windowWidth
    },
    setWindowHeight (state, windowHeight) {
      state.windowHeight = windowHeight
    },
    setUser (state, user) {
      state.user = user
    },
    setCurrentContract (state, currentContract) {
      state.currentContract = currentContract
    },
    setMyChart (state, myChart) {
      state.myChart = myChart
    },
    // setMyChart1 (state, myChart1) {
    //   state.myChart1 = myChart1
    // },
    setMyChart2 (state, myChart2) {
      state.myChart2= myChart2
    },
    // setMyChart3 (state, myChart3) {
    //   state.myChart3 = myChart3
    // },
    setChatData (state, chatData) {
      state.chatData = chatData
    },
    setTrendData (state, trendData) {
      state.trendData = trendData
    },
    setSignalData (state, signalData) {
      state.signalData = signalData
    },
    setResonanceData (state, resonanceData) {
      state.resonanceData = resonanceData
    },
    setStrategyData (state, strategyData) {
      state.strategyData = strategyData
    },
    setMarketData (state, marketData) {
      state.marketData = marketData
    },
    setRankData (state, rankData) {
      state.rankData = rankData
    },
    setReturnData (state, returnData) {
      state.returnData = returnData
    },
    setTechnicalData (state, technicalData) {
      state.technicalData = technicalData
    },
    setPickingData (state, pickingData) {
      state.pickingData = pickingData
    },
    setCorrelationData (state, correlationData) {
      state.correlationData = correlationData
    },
    setRegressionData (state, regressionData) {
      state.regressionData = regressionData
    },
    setHedgeData (state, hedgeData) {
      state.hedgeData = hedgeData
    },
    setHistoryData (state, historyData) {
      state.historyData = historyData
    },
    setBacktestData (state, backtestData) {
      state.backtestData = backtestData
    },
    // setInfoData (state, infoData) {
    //   state.infoData = infoData
    // },
    setMeData (state, meData) {
      state.meData = meData
    }
  },
  actions: {
  },
  modules: {
  }
})
